import { render, staticRenderFns } from "./drag-verify.vue?vue&type=template&id=2c25bd56&scoped=true&"
import script from "./drag-verify.vue?vue&type=script&lang=js&"
export * from "./drag-verify.vue?vue&type=script&lang=js&"
import style0 from "./drag-verify.vue?vue&type=style&index=0&id=2c25bd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25bd56",
  null
  
)

export default component.exports